import axios from 'axios';
import * as loadingActions from './loading.js';

export function loadSkills() {
  return(dispatch, getState) => {
    dispatch(loadingActions.loadingData(getState().loading));
    axios.get('https://api.qiydaarpratt.com/api/v1/tech_types').then((response)=>{
      dispatch(loadSkillsSuccess(response.data));
      dispatch(loadingActions.doneLoadingData(getState().loading));
    }).catch(error => dispatch(loadSkillsError(error)));
  }
}

export const loadSkillsStart = () => ({
  type: 'LOAD_SKILLS_START'
});

export const loadSkillsSuccess = skills_data => ({
  type: 'LOAD_SKILLS_SUCCESS',
  payload: skills_data
});

export const loadSkillsError = error => ({
  type: 'LOAD_SKILLS_ERROR',
  payload: error
});



// WEBPACK FOOTER //
// ./src/actions/skills.js